module.exports = __webpack_public_path__ + "img/河间汽配.7c802d7c.jpg";